import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useModal } from '../../contexts/ModalContext';

export default function RoomLists({roomList}) {
    const [active, setActive] = useState(0);
    const sectionRefs = useRef([]);

    const { openQueryModal } = useModal();

    const handleClick = (i) => {
        setActive(i);

        const offset = 90;
        const element = sectionRefs.current[i];
        if (!element) return;

        const y =
        element.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

        window.scrollTo({
        top: y,
        behavior: "smooth",
        });
    };

    useEffect(() => {
        const handleScroll = () => {

        const offset = 100;

        sectionRefs.current.forEach((section, index) => {
            if (!section) return;

            const rect = section.getBoundingClientRect();

            if (rect.top <= offset && rect.bottom > offset) {
            setActive(index);
            }
        });
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);

    }, []);

  return (
    <>
    <section>
        <section className="big-container room-catlist">
            <ul>
                {roomList.map((room, i) => (
                <li key={i} className={active === i ? "active" : ""} onClick={() => handleClick(i)}>
                    {room.category}
                </li>
                ))}
            </ul>
        </section>

        {roomList.map((room, index) => (
        <section key={index} ref={(el) => (sectionRefs.current[index] = el)} className={`room-listing-section ${ index === 0 ? "first-roomlist" : ""}`}>
            <div className="room-listing">
                <div className="container">
                    <div className="row align-items-end justify-content-end">
                        <div className="col-lg-4 col-md-5">
                            <div className="room-content wow animate__animated animate__fadeInUp">
                                {index === 0 ? (
                                    <h2 className="heading">{room.title}</h2>
                                    ) : (
                                    <span className="heading">{room.title}</span>
                                )}
                                <p>{room.description}</p>
                            </div>
                        </div>

                        <div className="col-lg-7 col-md-7"></div>
                    </div>
                </div>

                <div className="room-image-wrap"><img src={room.image} alt={room.title} className="img-responsive" loading={index === 0 ? undefined : "lazy"}/></div>
            </div>

            <div className="roomdetail-area">
                <div className="container">
                    <div className="row align-items-end justify-content-end">
                        <div className="col-lg-4 col-md-5">
                            <div className="room-actions">
                                <Link onClick={openQueryModal} className="arrow-butn">Enquire Now <img src="/image/right-arrow.svg" alt="arrow" /></Link>
                                <a href={room.bookLink} target='_blank' rel="noreferrer" className="arrow-butn">Book Directly <img src="/image/right-arrow.svg" alt="arrow" /></a>
                            </div>
                        </div>

                        <div className="col-lg-7 col-md-7">
                            <div className="room-details">
                                <Link to={room.detailLink} className="arrow-butn longarrow-butn">
                                <span class="sr-only">{room.title} </span>View Detail <img src="/image/longright-arrow.svg" alt="arrow" /></Link>
                                <ul>
                                    {room.specs.map((spec, i) => (
                                        <li key={i}>{spec}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        ))}
    </section>
    </>
  )
}
